import { useState } from 'react';
import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from '@/ui/components/ui/card';
import { Separator } from '@/ui/components/ui/separator';
import type { ProjectObject } from '../../hooks/use-admin';
import { AllowedOriginsForm } from './configuration/AllowedOriginsForm';
import { EmbedSnippets } from './configuration/EmbedSnippets';
import { HmacSecretSection } from './configuration/HmacSecretSection';

interface ConfigurationTabProps {
	project: ProjectObject;
	updateProject: (opts: {
		variables: { id: string; input: Partial<ProjectObject> };
	}) => Promise<unknown>;
	regenerateHmacSecret: (opts: {
		variables: { id: string };
	}) => Promise<unknown>;
	canEdit: boolean;
}

export function ConfigurationTab({
	project,
	updateProject,
	regenerateHmacSecret,
	canEdit,
}: ConfigurationTabProps) {
	const [hasSecret, setHasSecret] = useState(!!project.hmacSecret);

	return (
		<Card>
			<CardHeader>
				<CardTitle>Embed settings</CardTitle>
			</CardHeader>
			<CardContent className='flex flex-col gap-6'>
				<AllowedOriginsForm
					project={project}
					updateProject={updateProject}
					canEdit={canEdit}
				/>

				<Separator />

				<HmacSecretSection
					project={project}
					regenerateHmacSecret={regenerateHmacSecret}
					onSecretRevealed={() => setHasSecret(true)}
					canEdit={canEdit}
				/>

				{(hasSecret || project.hmacSecret) && (
					<>
						<Separator />
						<EmbedSnippets
							projectId={project.id}
							hmacSecret={project.hmacSecret ?? ''}
						/>
					</>
				)}
			</CardContent>
		</Card>
	);
}
